// extracted by mini-css-extract-plugin
export default {"Link":"link_Link__9HdEW"};